import React, {useState} from 'react';
import TextArea from "@/components/form/TextArea.tsx";
import Button from "@/components/form/Button.tsx";
import {getHttpClient} from "@/utils/api.ts";

function Support() {
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);
    const [response, setResponse] = useState(null)
    const contact = ()=>{
        setSending(true);
        getHttpClient().post('/utils/contact', {
            message
        }).then(({data})=>{
            setResponse(data)
            setMessage("");
            setSending(false);
        }).catch(()=>{
            setSending(false);
        })
    }
    return (
        <div className={"max-w-lg"}>
            <h1 className={"text-4xl mb-2"}>Help & Support</h1>
            <p className={"mb-3"}>Got questions, queries, concerns or feedback. Send us a message using the form below. You can also contact us directly at <a href={"mailto:admin@goaffpro.com"} className={"link"}>admin@goaffpro.com</a></p>
            {
                response?.message ? <p className={"mb-3 alert alert-success"}>{response.message}</p>
                    : null
            }
            <form>
                <div className="mb-3">
                    <TextArea
                        autosize
                        value={message}
                          onChange={setMessage}
                          placeholder={"Your message here"}
                    />
                </div>
                <Button onClick={contact} loading={sending} className={"btn btn-primary"}>Send Message</Button>
            </form>

        </div>
    );
}

export default Support;
